import { Statuses } from '../../../../../../../../../../../../constants/statuses';
import { createMap } from '../../../../../../../../../../../../utils/arrayUtil';
import { isPast } from '../../../../../../../../../../../../utils/dateUtil';

export const mergeDocumentRequirementsWithDocuments = (documentRequirements, documents) => {
  const normalDocReqs = [...documentRequirements]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(docReq => {
      const documentsForThisDocReq = documents
        .filter(doc => docReq.insuranceDocumentTypeId === doc.insuranceDocumentTypeId
          && ![Statuses.Deleted, Statuses.Archived, Statuses.Created].includes(doc.status));

      const expiredDoc = documentsForThisDocReq.find(doc => {
        const expiredPoliciesExist = doc.policies?.find(pol => isPast(pol.expiresAt));
        const expiredLinksExist = doc.expirations?.find(exp => isPast(exp.expiresAt));

        return expiredPoliciesExist || expiredLinksExist;
      });

      // optimistically calculate status without mutating the cached react-query object
      let { status } = docReq;
      if (expiredDoc && docReq.status !== Statuses.Waived) {
        status = Statuses.Expired;
      } else if (docReq.status === Statuses.Expired && docReq.insuranceRequirementDocumentStatus !== Statuses.Expired) {
        // if no expired document exists, then render the stored state
        status = docReq.insuranceRequirementDocumentStatus;
      }

      return {
        ...docReq,
        status,
        documents: documentsForThisDocReq
      };
    });

  const docRequirementTypeMap = createMap(documentRequirements, 'insuranceDocumentTypeId');

  const nonRequiredDocuments = documents
    .filter(doc => !docRequirementTypeMap[doc.insuranceDocumentTypeId]
      && ![Statuses.Deleted, Statuses.Archived, Statuses.Created].includes(doc.status));

  const nonRequiredDocTypeMap = createMap(nonRequiredDocuments, 'insuranceDocumentTypeId', true);

  const nonReqDocReqs = Object.keys(nonRequiredDocTypeMap).map(docTypeId => {
    const baseDoc = nonRequiredDocTypeMap[docTypeId][0];
    const { insurableId, insuranceDocumentType } = baseDoc;
    const docIds = nonRequiredDocTypeMap[insuranceDocumentType.id].map(doc => doc.id).toString();

    return {
      ...baseDoc,
      status: Statuses.NotRequired,
      policyOwnerId: null,
      insuredId: insurableId,
      insuranceDocumentIds: docIds ?? null,
      insurancePolicyIds: null,
      insurancePolicyOwnerIds: null,
      insuranceDocumentTypeName: insuranceDocumentType.name,
      insuranceDocumentTypeDisplayName: insuranceDocumentType.displayName,
      documents: nonRequiredDocTypeMap[insuranceDocumentType.id]
    };
  });

  return [
    ...normalDocReqs, ...nonReqDocReqs
  ];
};
